import { formApiUrl } from 'utils/url';

/**
 * Ferme une session côté serveur : sans ça, le refresh token resterait valide un an après la déconnexion.
 * `keepalive` : la requête part même si la page navigue aussitôt, et la déconnexion locale n'attend rien.
 * Best-effort, comme toute la déconnexion : une API injoignable ne doit pas empêcher de sortir.
 */
export function closeServerSession(refreshToken: string | null): void {
    if (!refreshToken) return;

    fetch(`${formApiUrl()}/auth/logout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', webapporigin: 'true' },
        body: JSON.stringify({ refreshToken }),
        keepalive: true,
    }).catch(() => undefined);
}
